<template>
  <div class="home">
    <!-- <section class="hero-searching-img">
      <div class="container">
        <div class="row">
          <div class="search-warper col-lg-5 col-md-12 ">
   <div class="heading text-center pb-3">
    <h1>How can we help?</h1>
   </div>
  <div class="searchBar">
            <input id="searchQueryInput" type="text" name="searchQueryInput" placeholder="Type to search" value="" />
            <button id="searchQuerySubmit" type="submit" name="searchQuerySubmit">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
</div>

        </div>
      </div>
    </section> -->
    <section class="hero-support-img">
      <div class="support-img pt-5">
        <img :src="`assets/img/support-2.png`" class="img-responsive pl-3" />
        <img :src="`assets/img/support-right.png`" class="img-responsive right-side-image pr-3" />

      </div>
      <div class="container">
        <div class="row justify-content-center">

          <div class="search-warper col-lg-8 col-md-8">
            <div class="heading text-center pb-3">
              <h1>How can we help?</h1>
            </div>
            <div class="searchBar">
              <global-search key="home"></global-search>
            </div>
          </div>


        </div>

      </div>
    </section>
    <div class="hello">
      <div class="container margin_80_55 pb-0">
        <div class="home-heading">
          <h3>FAQ</h3>
        </div>
        <div class="row">
          <div v-for="category in categoryList" :key="category.Id" class="col-lg-3 col-md-6">
            <router-link :to="'/faq/' + category.Id" class="box_feat">
              <i :class="category.Icon"></i>
              <h3 class="help-title">{{ category.Title }}</h3>
            </router-link>
          </div>
        </div>
      </div>

      <!-- <section class="faq-tutorials-ticket  margin_70_55">
      <div class="container">
        <div class="row d-flex ">

          <div class="col-lg-12">
            <div class="col-lg-4 col-md-6">
              <router-link to="/faq" class="box_feat">
            <i class="pe-7s-help1"></i>
            <h3>FAQ</h3>
          </router-link>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="col-lg-4 col-md-6">
              <router-link to="/faq" class="box_feat">
            <i class="pe-7s-help1"></i>
            <h3>FAQ</h3>
          </router-link>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="col-lg-4 col-md-6">
              <router-link to="/faq" class="box_feat">
            <i class="pe-7s-help1"></i>
            <h3>FAQ</h3>
          </router-link>
            </div>
          </div>

        </div>
      </div>
    </section> -->
      <div class="bg_color_1" v-if="bloglist.length > 0">
        <div class="container margin_50_55">
          <div class="home-heading">
            <h3>Blog</h3>       
          </div>
          <div class="row">
            <div class="col-12">
              <carousel :data="{ 'items': bloglist, 'type': 'Blog' }"></carousel>
            </div>
          </div>
          <!-- /row -->
          <p class="btn_home_align">
            <router-link class="btn_1 rounded" :to="{ name: 'Blog' }">View all</router-link>
          </p>
        </div>
        <!-- /container -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import BlogService from '../services/blog-service'
import CtegorieService from '../services/category-service'
import GlobalSearch from '../components/Common/globalSearch.vue'
import Carousel from '../components/Common/carousel.vue'
import _ from 'lodash'
export default {
  name: 'Home',
  props: {
    msg: String
  },
  data() {
    return {
      bloglist: [],
      categoryList: []
    }
  },
  components: {
    GlobalSearch,
    Carousel
  },
  filters: {
    truncate: function (text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...'
      } else {
        return text
      }
    }
  },
  mounted() {
    this.getBlogs()
    this.getCategory()
  },
  methods: {
    getBlogs() {
      BlogService.getBlogList().then(response => {
        if (response.data.Object) {
          this.bloglist = _.orderBy(response.data.Object.blogs).slice(0, 6)
        } else {
          this.bloglist = []
        }
      }),
      error => {
        console.log(error)
      }
    },
    getCategory() {
      CtegorieService.getcategoryList().then(response => {
        if(response.data.Status && response.data.Object){
          this.categoryList = response.data.Object.categories
          if(this.categoryList.length > 0){
            this.categoryList = _.filter(this.categoryList, { 'ParentId': 0 })
          }
        } else {
          this.categoryList = []
        }
      }),
      error => {
        console.log(error)
      }
    }
  }
}
</script>
